import React from 'react';

import styles from './MainFooterSocial.module.scss';

type Props = {
  icon: React.ReactNode;
  link: string;
};

export const MainFooterSocial: React.FC<Props> = ({ icon, link }) => {
  return (
    <a
      href={link}
      target="_blank"
      className={styles.footerSocial}
      rel="noopener noreferrer"
      aria-label="social link"
    >
      {icon}
    </a>
  );
};
